import {
  DATA_IMPORT_OPPORTUNITY,
  DATA_IMPORT_OPPORTUNITY_SUCCESS,
  DATA_IMPORT_OPPORTUNITY_FAILURE,
  DATA_IMPORT_SCHEMA,
  DATA_IMPORT_SCHEMA_SUCCESS,
  DATA_IMPORT_SCHEMA_FAILURE,
  DATA_IMPORT,
  DATA_IMPORT_SUCCESS,
  DATA_IMPORT_FAILURE,
  DATA_IMPORT_RESET,
  DATA_IMPORT_RESHAPE,
  DATA_IMPORT_RESHAPE_SUCCESS,
  DATA_IMPORT_RESHAPE_FAILURE,
  DATA_IMPORT_RESHAPE_RESET,
} from "./actionType";

//DATA_IMPORT_OPPORTUNITY
export const dataImportOpportunity = (data) => {
  return {
    type: DATA_IMPORT_OPPORTUNITY,
    payload: data,
  };
};
export const dataImportOpportunitySuccess = (data) => {
  return {
    type: DATA_IMPORT_OPPORTUNITY_SUCCESS,
    payload: data,
  };
};
export const dataImportOpportunityFailure = (error) => {
  return {
    type: DATA_IMPORT_OPPORTUNITY_FAILURE,
    payload: error,
  };
};

//DATA_IMPORT_SCHEMA
export const dataImportSchema = () => ({ type: DATA_IMPORT_SCHEMA });
export const dataImportSchemaSuccess = (data) => ({
  type: DATA_IMPORT_SCHEMA_SUCCESS,
  payload: data,
});
export const dataImportSchemaFailure = (error) => ({
  type: DATA_IMPORT_SCHEMA_FAILURE,
  payload: error,
});

//DATA_IMPORT
export const dataImport = (data) => ({ type: DATA_IMPORT, payload: data });
export const dataImportSuccess = (data) => ({
  type: DATA_IMPORT_SUCCESS,
  payload: data,
});
export const dataImportFailure = (error) => ({
  type: DATA_IMPORT_FAILURE,
  payload: error,
});
export const dataImportReset = () => ({ type: DATA_IMPORT_RESET });

//DATA_IMPORT_RESHAPE
export const dataImportReshape = (data) => ({
  type: DATA_IMPORT_RESHAPE,
  payload: data,
});
export const dataImportReshapeSuccess = (data) => ({
  type: DATA_IMPORT_RESHAPE_SUCCESS,
  payload: data,
});
export const dataImportReshapeFailure = (error) => ({
  type: DATA_IMPORT_RESHAPE_FAILURE,
  payload: error,
});
export const dataImportReshapeReset = () => ({
  type: DATA_IMPORT_RESHAPE_RESET,
});
